<div [style.display]="isVisible() ? 'block' : 'none'" class="image-item-wrapper">
  <div
    class="image-wrapper"
    [ngStyle]="{
      'width.px': imageSize().width > 0 ? imageSize().width : null,
      'height.px': imageSize().height > 0 ? imageSize().height : null
    }"
    draggable="false">
    @if (src()) {
      <img
        [attr.width]="imageSize().width > 0 ? imageSize().width : null"
        [attr.height]="imageSize().height > 0 ? imageSize().height : null"
        [src]="src()"
        [alt]="alt()"
        draggable="false" />
    }
    <div class="image-overlay" draggable="false"></div>
  </div>
</div>
